<ng-container [ngSwitch]="currentState">
  <ng-container *ngSwitchCase="favouriteState.FAVOURITE_LIST">
    <div class="ui basic segments">
      <div class="ui basic segment">
        <div class="ui list">
          <div
            class="item"
            *ngFor="let item of favouriteList"
            (click)="addToFavouriteList(item)"
          >
            <img
              class="ui tiny avatar image"
              *ngIf="item?.screens?.length === 0"
              src="assets/images/Image1.png"
            />
            <img
              class="ui tiny avatar image"
              *ngIf="
                item?.screens?.length !== 0 &&
                  ((item?.screens)[item?.screens?.length - 1].screen | docRef)
                  | async as screeData
              "
              [src]="(screeData?.screenImages)[0]?.url"
            />
            <div class="content">
              <a class="header">
                {{ item.favouriteListName }}
              </a>
              <div class="description">{{ item.screens.length }} screens</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ui basic segment">
        <div
          class="ui primary fluid button"
          (click)="currentState = favouriteState.ADD_FAVOURITE"
        >
          Create List
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="favouriteState.ADD_FAVOURITE">
    <div class="ui placeholder segment">
      <div class="ui icon header">Favourite List Name</div>
      <form class="ui form" [formGroup]="favouriteListForm">
        <div class="field">
          <input
            type="text"
            name="favouriteListName"
            placeholder="Name"
            formControlName="favouriteListName"
          />
          <span
            class="ui error text"
            *ngIf="
              favouriteListForm?.controls.favouriteListName.hasError(
                'required'
              ) && favouriteListForm?.controls.favouriteListName.touched
            "
            >{{
              favouriteListForm?.controls.favouriteListName.errors.required
                .message
            }}</span
          >
          <span
            class="ui error text"
            *ngIf="
              favouriteListForm?.controls.favouriteListName.hasError(
                'maxLength'
              )
            "
            >{{
              favouriteListForm?.controls.favouriteListName.errors.maxLength
                .message
            }}</span
          >
        </div>
        <div class="ui primary button" (click)="createList()">Create List</div>
      </form>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="favouriteState.NO_LIST">
    <div class="ui placeholder segment">
      <div class="ui icon header">
        <i class="heart pink icon"></i>
        No Favourite List.
      </div>
      <div
        class="ui primary button"
        (click)="currentState = favouriteState.ADD_FAVOURITE"
      >
        Create List
      </div>
    </div>
  </ng-container>
</ng-container>
